import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=cda4db46&lang=pug"
import script from "./JobForm.vue?vue&type=script&lang=ts"
export * from "./JobForm.vue?vue&type=script&lang=ts"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=cda4db46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QStepper,QStep,QStepperNavigation,QBtn});
